import { Button } from "@/components/ui/button"
import { SiGithub, SiX, SiLinkedin, SiDiscord } from "react-icons/si";
import Logo from "@/components/logo"
import { useNavigate } from 'react-router-dom';

const LandingFooter = () => {
  const navigate = useNavigate();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="border-t">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company & Description */}
          <div className="space-y-4 lg:col-span-2">
            <Logo />
            <p className="text-muted-foreground text-sm max-w-xs">
              AI-Driven command center for software teams. Daily insights and 24/7 monitoring keep your team aligned and site up.
            </p>
            <div className="flex space-x-4">
              <Button variant="ghost" size="icon" className="hover:text-primary">
                <SiX className="w-4 h-4" />
              </Button>
              <Button variant="ghost" size="icon" className="hover:text-primary">
                <SiGithub className="w-4 h-4" />
              </Button>
              <Button variant="ghost" size="icon" className="hover:text-primary">
                <SiLinkedin className="w-4 h-4" />
              </Button>
              <Button variant="ghost" size="icon" className="hover:text-primary">
                <SiDiscord className="w-4 h-4" />
              </Button>
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h3 className="font-medium text-sm text-muted-foreground">Product</h3>
            <ul className="space-y-3">
              <li><Button variant="link" className="h-auto p-0" onClick={() => scrollToSection('features')}>Features</Button></li>
              <li><Button variant="link" className="h-auto p-0" onClick={() => scrollToSection('pricing')}>Pricing</Button></li>
              <li><Button variant="link" className="h-auto p-0" onClick={() => navigate('/changelog')}>Changelog</Button></li>
              <li><Button variant="link" className="h-auto p-0" onClick={() => navigate('/support')}>Support</Button></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="space-y-4">
            <h3 className="font-medium text-sm text-muted-foreground">Contact</h3>
            <ul className="space-y-3">
              <li><Button variant="link" className="h-auto p-0">help@status.bot</Button></li>
              <li><Button variant="link" className="h-auto p-0" onClick={() => navigate('/support')}>Support</Button></li>
              <li><Button variant="link" className="h-auto p-0" onClick={() => navigate('/privacy')}>Privacy & Terms</Button></li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-muted-foreground">
              © {new Date().getFullYear()} StatusBot, Inc. All rights reserved.
            </p>
            <div className="flex items-center space-x-4">
              <Button variant="ghost" size="sm">
                <span className="flex items-center space-x-2">
                  <div className="relative">
                    <div className="w-2 h-2 bg-emerald-400 rounded-full" />
                    <div className="absolute inset-0 w-2 h-2 bg-emerald-400 rounded-full animate-ping" />
                  </div>
                  <span className="text-xs">All systems operational</span>
                </span>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default LandingFooter; 